import { Tooltip } from '@mui/material';
import {  observer } from 'mobx-react';
import React from 'react';
import AutoComplete from '../../misc/AutoComplete';
import { Processo } from '../../modelo';
import { ComplementoGEDTO, ComplementosPossiveisDto, MovimentoGEDTO } from '../../modelo/MinutaMovimentos';
import MovimentoService from '../../services/MovimentoService';

interface IPropsComplementoAutocomplete {
    processo: Processo;
    movimento: MovimentoGEDTO;
    complemento: ComplementosPossiveisDto;
    listaDeComplementos: ComplementoGEDTO[];
    handleCallbackAutoComplete: (evento, retorno) => any;
    lote?: boolean;
}


class ComplementoAutocomplete extends React.Component<IPropsComplementoAutocomplete> {
    componentDidMount(): void {
        const complementoSetado = this.props.complemento.opcoes.find(op => op.valor.valor === this.complementoSetado?.valor || op.valor.valor === (this.complementoSetado as any) || op.valor.valor === this.siglaParaDescricaoClasse(this.props.processo.classe))
        if (complementoSetado) {
            this.props.handleCallbackAutoComplete(undefined, complementoSetado)
        }
    }

    get isDisabled(): boolean {
        const nomeDominio: string = this.props.complemento.stringComplemento;
        const excludente = MovimentoService.existeComplementoExcludente(nomeDominio, this.props.movimento);
        const compExcludente = excludente?.length ? this.props.listaDeComplementos.find(comp => excludente.includes(comp.stringComplemento)) : undefined;
        return (this.props.lote && this.props.complemento.stringComplemento.toLowerCase().includes('nome da parte')) || !!compExcludente?.valorSetado;
    }

    get complementoSetado(): ComplementoGEDTO {
        let json = this.props.movimento.complementos?.find(comp =>
            comp.stringComplemento
            && this.props.complemento.stringComplemento
            && (comp.stringComplemento.toLocaleLowerCase() === this.props.complemento.stringComplemento.toLocaleLowerCase()));
        if (json) {
            try {
                json = JSON.parse(json.valorSetado);
            } catch (_e) {
                json = json.valorSetado as any;
            }
        }
        return json
    }

    callback = (evento, retorno) => {
        this.props.handleCallbackAutoComplete(evento, retorno);
    }

    siglaParaDescricaoClasse(sigla: string) {
        switch (sigla.split('-')[0]) {
            case 'Ag':
                return 'Agravo'
            case 'AIRR':
                return 'Agravo de Instrumento em Recurso de Revista'
            case 'AgRE':
                return 'Agravo de Instrumento em Recurso Extraordinário'
            case 'AIRO':
                return 'Agravo de Instrumento em Recurso Ordinário'
            case 'AIROSTF':
                return 'Agravo de Instrumento em Recurso Ordinário para o STF'
            case 'Emb':
                return 'Embargos'
            case 'EDCiv':
                return 'Embargos de Declaração'
            case 'EIT':
                return 'Embargos Infringentes'
            case 'RR':
                return 'Recurso de Revista'
            case 'RE':
                return 'Recurso Extraordinário'
            case 'ROT':
                return 'Recurso Ordinário'
            case 'RemNecCiv':
                return 'Reexame Necessário'
            case 'RemNecRO':
                return 'Reexame Necessário/Recurso Ordinário'
            default:
                break;
        }
    }

    render() {
        return (
            <Tooltip title={this.props.lote && this.props.complemento.stringComplemento.toLowerCase().includes('nome da parte') ? 'Em lote, são atribuídos automaticamente pelo sistema' : ''} placement='bottom-start'>
                <div>
                <AutoComplete
                    disabled={this.isDisabled}
                    freeSolo
                    width='100%'
                    callback={this.callback}
                    options={this.props.complemento.opcoes}
                    defaultValue={this.props.complemento.opcoes.find(op => op.valor.valor === this.complementoSetado?.valor || op.valor.valor === (this.complementoSetado as any) || op.valor.valor === this.siglaParaDescricaoClasse(this.props.processo.classe))}
                    label={this.props.complemento.stringComplemento}
                    id={'processo-' + this.props.processo.identificadorProcesso + '-mov-' + this.props.movimento.codMovimentoCnj + '-complemento-' + this.props.complemento.stringComplemento}
                />
                </div>
            </Tooltip>
        );
    }
}

export default observer(ComplementoAutocomplete);
